import React from 'react';
import { Helmet } from 'react-helmet';
import { PropTypes } from 'prop-types';

function GoogleAnalytics({ market }) {
    const hotjar = market === 'UK' ? 781721 : 2089789;
    //const testGTMTag = market ===  'UK' ? 'GTM-P95KSCP';
    const liveGTMTag = market === 'UK' ? 'GTM-P4NMQH' : 'GTM-MMGQFGH';
    return (
        <>
            <Helmet>
                {/* Google Tag Manager */}
                <script>{`
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(
                {'gtm.start': new Date().getTime(),event:'gtm.js'}
                );var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.defer=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${liveGTMTag}');
            `}</script>
                {/* End Google Tag Manager */}

                <script>{`
                (function(h,o,t,j,a,r){
                    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                    h._hjSettings={hjid:${hotjar},hjsv:6};
                    a=o.getElementsByTagName('head')[0];
                    r=o.createElement('script');r.async=1;r.defer=1;
                    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                    a.appendChild(r);
                })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
            `}</script>
                <script
                    type='text/javascript'
                    src='https://cdn-3.convertexperiments.com/js/10021747-10021785.js'
                    defer
                ></script>
            </Helmet>
        </>
    );
}

GoogleAnalytics.propTypes = {
    market: PropTypes.string
};

export { GoogleAnalytics };
